export const escapeValue = (value: string) => {
  // Backslashes first, before the quote and line break escapes add their own: the value goes into
  // a JSON string (the form payload), where a lone one would start an invalid escape, swallow the
  // closing quote or turn into another character (`C:\new`).
  const escapedBackslashes = value.replace(/\\/g, "\\\\");
  const escapedQuotes = escapedBackslashes.replace(/"/g, '\\"');
  const escapedLineBreaks = escapedQuotes.replace(/(\r\n|\r|\n)/g, "\\n");
  const trimmed = escapedLineBreaks.trim();

  return trimmed;
};
